(() => {
  'use strict';

  if (window.ZepShippingEstimator) {
    window.ZepShippingEstimator.initAll();
    return;
  }

  const RATE_RULES = Object.freeze([
    { min: 0, max: 5000, rate: 29.99 },
    { min: 5010, max: 10000, rate: 34.99 },
    { min: 10010, max: 15000, rate: 39.99 },
    { min: 15010, max: 25000, rate: 43.99 },
    { min: 25010, max: 40000, rate: 74.99 },
    { min: 40010, max: 60000, rate: 99.99 },
    { min: 60010, max: 79990, rate: 109 },
    { min: 80000, max: 109900, rate: 121 },
    { min: 110000, max: 149900, rate: 151 },
    { min: 150000, max: 179900, rate: 179 },
    { min: 180000, max: 249000, rate: 250 },
    { min: 250000, max: 999000, rate: 300 }
  ]);

  const formatRate = (rate) => new Intl.NumberFormat('ro-RO', {
    minimumFractionDigits: Number.isInteger(rate) ? 0 : 2,
    maximumFractionDigits: 2
  }).format(rate);

  const estimate = (grams) => {
    const value = Number(grams);
    if (!Number.isFinite(value) || value < 0) return null;
    const rule = RATE_RULES.find((item) => value >= item.min && value <= item.max);
    return rule ? rule.rate : null;
  };

  const getPdpState = (element) => {
    let variants = [];
    try {
      variants = JSON.parse(element.dataset.variants || '[]');
    } catch (_error) {
      return { unknown: true, grams: 0 };
    }

    const form = element.closest('form[data-type="add-to-cart-form"]') || element.closest('form');
    const variantInput = form && form.querySelector('[name="id"]');
    const quantityInput = form && form.querySelector('[name="quantity"]');
    const variantId = String((variantInput && variantInput.value) || element.dataset.selectedVariant || '');
    const variant = variants.find((item) => String(item.id) === variantId);
    const quantity = Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);

    if (!variant) {
      return { unknown: true, grams: 0 };
    }

    return {
      unknown: false,
      grams: Number(variant.weight || 0) * quantity,
      subtotal: Number(variant.price || 0) * quantity
    };
  };

  const render = (element) => {
    if (!element || !element.isConnected) return;

    const context = element.dataset.context;
    const state = context === 'pdp'
      ? getPdpState(element)
      : {
          unknown: false,
          grams: Number(element.dataset.weight || 0),
          subtotal: Number(element.dataset.subtotal || 0)
        };

    const main = element.querySelector('.zep-shipping-estimator__main');
    const heavy = element.querySelector('.zep-shipping-estimator__heavy');
    const note = element.querySelector('.zep-shipping-estimator__note');
    if (!main || !heavy) return;

    const rate = state.unknown
      ? null
      : (state.subtotal > 0 && state.subtotal <= 13900 ? 19.99 : estimate(state.grams));

    if (context === 'pdp') {
      if (rate === null) {
        main.textContent = 'Livrare în România';
        heavy.hidden = true;
        if (note) {
          note.hidden = false;
          note.textContent = 'Cost calculat în coș';
        }
        element.dataset.estimateStatus = 'unknown';
        return;
      }

      main.textContent = 'Livrare estimată: ' + formatRate(rate) + ' lei';
      heavy.hidden = state.grams <= 40000;
      if (note) {
        note.hidden = state.grams > 40000;
        note.textContent = 'Livrare în România';
      }
    } else {
      if (rate === null) {
        main.textContent = 'Livrare: Cost calculat în checkout';
        heavy.hidden = true;
        element.dataset.estimateStatus = 'unknown';
        return;
      }

      main.textContent = 'Livrare estimată: ' + formatRate(rate) + ' lei';
      if (context === 'minicart') {
        main.textContent += ' · 24–72 ore';
      }
      heavy.hidden = context === 'minicart' || state.grams <= 40000;
    }
    element.dataset.estimateStatus = 'estimated';
    element.dataset.estimatedRate = String(rate);
    element.dataset.estimatedWeight = String(state.grams);
  };

  let cartRefreshTimer = null;

  const refreshCartEstimators = async () => {
    const elements = document.querySelectorAll(
      '[data-zep-shipping-estimator][data-context="cart"], [data-zep-shipping-estimator][data-context="minicart"]'
    );
    if (!elements.length) return;

    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });
      if (!response.ok) return;

      const cartState = await response.json();
      const isEmpty = Number(cartState.item_count || 0) === 0;
      const hasZeroWeight = !isEmpty && (cartState.items || []).some(
        (item) => item.requires_shipping && Number(item.grams || 0) === 0
      );

      elements.forEach((element) => {
        element.hidden = isEmpty;
        if (isEmpty) {
          delete element.dataset.estimatedRate;
          delete element.dataset.estimatedWeight;
          element.dataset.estimateStatus = 'empty';
          return;
        }

        element.dataset.weight = String(Number(cartState.total_weight || 0));
        element.dataset.subtotal = String(Number(cartState.total_price || 0));
        element.dataset.hasZeroWeight = String(hasZeroWeight);
        render(element);
      });
    } catch (_error) {
      // Pastreaza ultima estimare vizibila daca endpoint-ul cart nu raspunde.
    }
  };

  const scheduleCartRefresh = (delay = 120) => {
    window.clearTimeout(cartRefreshTimer);
    cartRefreshTimer = window.setTimeout(refreshCartEstimators, delay);
  };

  const isCartRequest = (url = '') => /\/cart(?:\/(?:add|change|update|clear))?(?:\.js)?(?:\?|$)/.test(String(url));

  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build', 'theme:cart:change'].forEach((eventName) => {
    document.addEventListener(eventName, () => scheduleCartRefresh());
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest(
      'a[href*="/cart/change"], [data-cart-remove], [data-remove-item], .cart__remove, .mini_cart_remove, .js_plus, .js_minus'
    )) scheduleCartRefresh(700);
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches(
      'input[name="updates[]"], input[name="quantity"], [data-cart-quantity], .cart__qty-input'
    )) scheduleCartRefresh(700);
  });

  if (window.jQuery) {
    window.jQuery(document).on('ajaxComplete.zepShippingEstimator', (_event, _xhr, settings) => {
      if (settings && isCartRequest(settings.url)) scheduleCartRefresh();
    });
  }

  const init = (element) => {
    if (!element || element.dataset.zepEstimatorReady === 'true') return;
    element.dataset.zepEstimatorReady = 'true';
    render(element);

    if (element.dataset.context === 'pdp') {
      const form = element.closest('form[data-type="add-to-cart-form"]') || element.closest('form');
      if (form) {
        ['change', 'input'].forEach((eventName) => {
          form.addEventListener(eventName, () => window.setTimeout(() => render(element), 0));
        });
        form.addEventListener('click', () => window.setTimeout(() => render(element), 0));
      }
    }
  };

  const initAll = (root = document) => {
    if (root.nodeType === 1 && root.matches('[data-zep-shipping-estimator]')) init(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('[data-zep-shipping-estimator]').forEach(init);
    }
  };

  window.ZepShippingEstimator = Object.freeze({ RATE_RULES, estimate, render, initAll });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) initAll(node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleCartRefresh(0), { once: true });
  } else {
    scheduleCartRefresh(0);
  }
})();
